import React, { useEffect } from 'react';

import { Container, Pagination } from '@mui/material';
import { observer } from 'mobx-react';

import classes from './NgzCustomerCommunicationList.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { CustomerRow } from './CustomerRow/CustomerRow';
import { TitleRow } from './TitleRow/TitleRow';
import { FilterRow } from './FilterRow/FilterRow';
import { customerCommunicationStore } from '../../stores/customerCommunicationStore';
import { CustomerCommunicationPageTitle } from './CustomerCommunicationPageTitle/CustomerCommunicationPageTitle';
import { useCustomFilter } from '../../../shared/features/custom-filter';
import { EmptyList } from '../../../shared/components/ui-components';

const NgzCustomerCommunicationList = observer(() => {
  const { customerList, getCustomerListInitData, filterMethod } =
    customerCommunicationStore;
  const { isShowPagination, isShowPlaceholder, isSearchUsed, getPaginationProps } =
    filterMethod;

  useCustomFilter('customers');

  useEffect(() => {
    getCustomerListInitData();
  }, []);

  const paginationProps = getPaginationProps();

  return (
    <Container>
      <CustomerCommunicationPageTitle />
      <div className={classes.customerTable}>
        <TitleRow />
        <FilterRow />
        {customerList.map((userInfo) => (
          <CustomerRow userInfo={userInfo} key={userInfo.id} />
        ))}
      </div>
      {isShowPagination && <Pagination {...paginationProps} />}
      <EmptyList
        show={isShowPlaceholder}
        isSearch={isSearchUsed}
        description="There are no customers"
      />
    </Container>
  );
});

angularizeWithProviders(NgzCustomerCommunicationList, 'ngzCustomerCommunicationList', {});

export default NgzCustomerCommunicationList;
